<template>
  <div class="container">
    <breadcrumb-group :items="breadcrumbItems" v-if="!isAuWallet()"/>

    <heading-one class="-margin-md">暗証番号の再設定</heading-one>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="1" type="userpassword"></main-wizard>
    </wizard-group>

    <section>
      <notice-box class="-success">
        <notice-header>
          <h3 class="heading">暗証番号の再設定が完了いたしました。</h3>
        </notice-header>
        <notice-body>暗証番号は、非常に重要な情報となるため、第三者に知られることのないよう十分にご注意ください。</notice-body>
      </notice-box>
    </section>

    <btngroup-single class="-margin-lg">
      <btn-main class="-main" routerName="mb001" v-if="!isAuWallet()">
        会員さま専用サイトトップへ
      </btn-main>
      <btn-main class="-main" routerName="mb012" v-else>
        au PAY 残高にチャージ
      </btn-main>
    </btngroup-single>

  </div><!-- container -->
</template>

<script>
import { isAuWallet } from '../utils/UserAgent'
import HeadingOne from '../components/heading/HeadingOne'
import MainWizard from '../components/wizard/MainWizard'
import WizardGroup from '../components/wizard/WizardGroup'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import NoticeBox from '../components/box/NoticeBox'
import NoticeBody from '../components/box/NoticeBody'
import NoticeHeader from '../components/box/NoticeHeader'

export default {
  name: 'mb-034',
  metaInfo: {
    title: '暗証番号の再設定',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き'}
    ]
  },
  components: {
    NoticeHeader,
    NoticeBody,
    NoticeBox,
    BtnMain,
    BtngroupSingle,
    WizardGroup,
    MainWizard,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: '暗証番号の再設定',
        active: true
      }]
    }
  },
  methods: {
    isAuWallet: function () {
      return isAuWallet()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Mb034.vue